import baseAPI from "@/api/base";
import { EditNote, GetNote, RegisterNote } from "@/dtos/Note.dto";
import {
  DELETE_NOTE_URL,
  EDIT_NOTE_URL,
  GET_NOTE_URL,
  REGISTER_NOTE_URL,
  TOGGLE_NOTE_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Note {
  static getNotes = async (getNote: GetNote): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_NOTE_URL, {
      params: getNote,
    });
    return response;
  };

  static registerNote = async (registerNote: RegisterNote): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_NOTE_URL, {
      ...registerNote,
    });
    return response;
  };

  static editNote = async (editNote: EditNote): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_NOTE_URL, {
      ...editNote,
    });
    return response;
  };

  static toggleNoteIsActive = async (editNote: EditNote): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_NOTE_IS_ACTIVE_URL, {
      ...editNote,
    });
    return response;
  };

  static deleteNote = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_NOTE_URL}/${id}`);
    return response;
  };
}

export default Note;
